export enum ExpressionFunctionType {
  BEGINS_WITH = 'begins_with',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'not contains',
  NOT_BEGINS_WITH = 'not begins_with',
  EXISTS = 'attribute_exists',
  NOT_EXISTS = 'attribute_not_exists',
}

export const isExpressionFunctionType = (possibleEnumValue: ExpressionFunctionType | ComparisonType) =>
  Object.values(ExpressionFunctionType).includes(possibleEnumValue as ExpressionFunctionType)

export enum ComparisonType {
  EQUALS = '=',
  NOT_EQUALS = '<>',
  LESS_THAN = '<',
  LESS_EQUAL = '<=',
  GREATER_THAN = '>',
  GREATER_EQUAL = '>=',
}

export const isComparisonType = (possibleEnumValue: ExpressionFunctionType | ComparisonType) =>
  Object.values(ComparisonType).includes(possibleEnumValue as ComparisonType)

export enum LogicalOperatorType {
  AND = 'and',
  OR = 'or',
}

const NULL_VALUE_PREDICATES = [ExpressionFunctionType.EXISTS, ExpressionFunctionType.NOT_EXISTS] as (
  | ExpressionFunctionType
  | ComparisonType
  | LogicalOperatorType
)[]

export const isNullValueFilterPartType = (filterPartType: BaseFilterType): filterPartType is NullValueFilterPartType =>
  NULL_VALUE_PREDICATES.includes(filterPartType.predicate)

export type BaseFilterType = {
  key: string
  value?: string | number | boolean | undefined
  predicate: ExpressionFunctionType | ComparisonType
}

export type FilterPartType = BaseFilterType & {
  value: string | number | boolean
}

export type NullValueFilterPartType = BaseFilterType & {
  value?: undefined
  predicate: ExpressionFunctionType.EXISTS | ExpressionFunctionType.NOT_EXISTS
}

export type AllFilterPartTypes = FilterPartType | NullValueFilterPartType

export type FilterGroup = {
  filters: (FilterPartType | NullValueFilterPartType)[]
  setOperation: LogicalOperatorType
}

const isFilterPartType = (x: any): x is FilterPartType => {
  const y = x as FilterPartType
  const requiredKeys: (keyof FilterPartType)[] = ['key', 'predicate']
  const yKeys = Object.keys(y)
  return requiredKeys.every((k) => yKeys.includes(k))
}

export const isFilterGroup = (x: any): x is FilterGroup => {
  const y = x as FilterGroup
  const hasSetOperation = [LogicalOperatorType.AND, LogicalOperatorType.OR].includes(y.setOperation)
  const hasValidFilterParts = y.filters.every(isFilterPartType)
  return hasSetOperation && hasValidFilterParts
}
